import { WidgetContentBlock } from '@r/components/widget/widget-content-block.tsx';
import type { WidgetSlideContent } from '@r/helpers/widget-workspace-slides.ts';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '@r/components/ui/dialog.tsx';

interface ContentBlockWidgetPreviewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  slides: WidgetSlideContent[];
  t: (key: string, options?: Record<string, unknown>) => string;
}

/** Modale d’aperçu participant du bloc (carousel ou slide unique). */
export const ContentBlockWidgetPreviewDialog = ({
  open,
  onOpenChange,
  slides,
  t
}: ContentBlockWidgetPreviewDialogProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="w-[calc(100vw-2rem)] max-w-[1320px] gap-6">
      <DialogHeader>
        <DialogTitle>{t('admin.contentblock.editor.preview.title')}</DialogTitle>
        <DialogDescription>{t('admin.contentblock.editor.preview.description')}</DialogDescription>
      </DialogHeader>
      <WidgetContentBlock slides={slides} enableAutoplay={false} displaySize="large" />
    </DialogContent>
  </Dialog>
);
